import conf from '../../conf';
import { setAviatorCrushPromptCookie } from '../../lib/aviator-crush-prompt-cookie';
import { checkIsAuthenticated, getAuthLogout } from '../../lib/helpers';

// D14 (PF-8560, refined 2026-08-26): AvaApp's session isn't replaced by following a magic
// link (see avaapp's auth.js/session.js) - an attendee already signed in as someone else has
// to be logged out first, or the magic link is wasted and they land in chat as their old
// identity. An attendee already signed in as the Crush temp user can skip straight to chat.
//
// checkIsAuthenticated(), not just window.AvaAppUser, decides whether anyone is logged in at
// all - an aui-only session (no AvaAppUser) is still an existing identity the magic link would
// clash with, so it must go through logout too, same as any other non-Crush AvaAppUser session.
// crushPrompt (PF-8767): the logout branch below needs no handling for it - getAuthLogout()'s
// returnUrl is built from the current document.location, which still carries the query param.
export const getExistingSessionRedirect = (crushPrompt?: string): string | null => {
  if (!checkIsAuthenticated()) return null;

  const avataxAccountId = window.AvaAppUser?.avataxAccountId;
  if (conf.CRUSH_AVATAX_ACCOUNT_ID && avataxAccountId === conf.CRUSH_AVATAX_ACCOUNT_ID) {
    // CLIENT_URL (AvaApp shell root), not BUY_CLIENT_URL (includes /buy) - the chat destination
    // is aviator-client's `/aviator-crush` route, a top-level alias with no `/buy` prefix (its
    // router has no basename, unlike this app's), not this app's own lead-capture landing page.
    // crushPrompt rides in a cookie, not a query param (PF-8804) - Identity's redirect_uri
    // allowlist isn't in play here, but this keeps aviator-client reading the prompt from a
    // single source regardless of which buy-dot path sent it there.
    if (crushPrompt) setAviatorCrushPromptCookie(crushPrompt);
    return `${conf.CLIENT_URL}/aviator-crush`;
  }

  return `${conf.CLIENT_URL}${getAuthLogout()}`;
};
